<template>
  <div class="step-three">
    <div class="form-group">
      <label>
        8. Paid Media annual budget
      </label>
      <HotTable :root="paidMediaId" ref="paidMediaId" :settings="paidMedia"></HotTable>
    </div>
    <div v-bind:class="{ 'invalid-field': (!validate['step3']) }" v-bind:id="checkValidate = validate['step3']">
      <p class="error-msg">Please add valid entry in above table.</p>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </div>
</template>
<script>
import HotTable from 'vue-handsontable-official'
import Simplert from 'vue2-simplert'

export default {
  components: {
    HotTable,
    Simplert
  },
  props: ['inputData', 'createdObject', 'validate', 'viewObject', 'modelType'],
  data () {
    return {
      annualSpend: this.createdObject.initial_annual_spend['table-data'],
      paidMediaId: 'paid-media',
      checkValidate: '',
      totalBudget: 0,
      paidMedia: {
        autoWrapRow: true,
        width: 600,
        height: 287,
        maxColsNumber: 2,
        colWidths: 180,
        data: [],
        colHeaders: ['Paid Media', 'Total Budget'],
        className: 'esheetclass view-only',
        tableClassName: 'exceltablestyle createtable paid-media',
        allowInsertRow: false,
        fillHandle: {
          autoInsertRow: false
        },
        invalidCellClassName: 'htInvalid',
        beforePaste: this.mediaPaste,
        columns: [
          {
            data: 'name',
            readOnly: true
          },
          {
            validator: /^(((\d{1,3})(,\d{2})*)|(\d+))(.\d+)?$/
          }
        ],
        cells: function (row, col, prop) {
          var cellProperties = {}
          if (col === 1 && row === this.instance.getData().length - 1) {
            cellProperties.readOnly = true
          }
          return cellProperties
        }
      }
    }
  },
  activated () {
    if (this.modelType === 'view') {
      this.totalBudget = 0
      for (let col in this.paidMedia.columns) {
        this.paidMedia.columns[col].readOnly = true
      }
      this.paidMedia.data = []
      for (let spend in this.viewObject.AnnualSpend) {
        this.paidMedia.data.push({name: this.viewObject.AnnualSpend[spend].name, 1: this.viewObject.AnnualSpend[spend].spend})
        this.totalBudget += this.viewObject.AnnualSpend[spend].spend
      }
      this.paidMedia.data.push({'name': 'Total Budget', 1: this.totalBudget})
    } else if (this.modelType === 'create') {
      this.paidMedia.afterChange = this.paidMediaChanged
      this.paidMedia.init = this.updateMedia
      let addTotal = ''
      let spend = 0
      let loopVar = 1
      let spendLength = this.paidMedia.data.length
      while (loopVar <= spendLength) {
        if (spend < 0) {
          spend = 0
        }
        if (this.annualSpend['Channels'][spend] !== undefined) {
          if (this.paidMedia.data[spend].name !== this.annualSpend['Channels'][spend]) {
            this.$refs.paidMediaId.table.alter('remove_row', spend)
            --spend
          } else {
            ++spend
          }
        } else {
          if (this.paidMedia.data[spend].name !== 'Total Budget') {
            this.$refs.paidMediaId.table.alter('remove_row', spend)
          }
        }
        loopVar++
      }
      for (let spendAdd in this.annualSpend['Channels']) {
        if (this.paidMedia.data[parseInt(spendAdd)] === undefined) {
          this.$refs.paidMediaId.table.alter('insert_row', parseInt(spendAdd))
          this.paidMedia.data[parseInt(spendAdd)].name = this.annualSpend['Channels'][spendAdd]
          addTotal = true
        }
      }
      if (addTotal && addTotal !== '') {
        this.paidMedia.data.push({'name': 'Total Budget', 1: 0})
      }
      this.totalBudgetFunc()
    }
  },
  watch: {
    checkValidate: function (val) {
      if (!val) {
        this.$refs.paidMediaId.table.validateCells()
      }
    }
  },
  methods: {
    paidMediaChanged (changes, source) {
      for (let key in changes) {
        let spendValue = changes[key][3]
        spendValue = spendValue.replace(/,/gi, '')
        this.annualSpend['Annual spend'][changes[key][0]] = spendValue
      }
      this.totalBudgetFunc()
      if (changes) {
        this.$emit('stepValidate')
      }
    },
    totalBudgetFunc () {
      this.totalBudget = 0
      for (let val in this.annualSpend['Annual spend']) {
        let validNum = new RegExp(/^\d+[.]?\d+$/)
        if (validNum.test(this.annualSpend['Annual spend'][val])) {
          this.totalBudget += parseInt(this.annualSpend['Annual spend'][val])
        }
      }
      this.paidMedia.data[this.paidMedia.data.length - 1][1] = this.totalBudget
    },
    updateMedia () {
      this.paidMedia.data = []
      for (var key in this.annualSpend['Channels']) {
        let annualSpendValue = this.annualSpend['Annual spend'][key]
        if (annualSpendValue === undefined) {
          annualSpendValue = ''
        }
        this.paidMedia.data.push({'name': this.annualSpend['Channels'][key]})
        if (annualSpendValue !== undefined) {
          this.paidMedia.data[key][1] = annualSpendValue
        }
      }
      this.paidMedia.data.push({'name': 'Total Budget', 1: 0})
    },
    mediaPaste (data, coords) {
      if (data.length > this.annualSpend['Channels'].length) {
        let modelCreatedModal = {
          title: '',
          message: 'Please add values for ' + this.annualSpend['Channels'].length + ' Media only',
          type: 'error',
          customCloseBtnClass: 'btn btn-primary'
        }
        this.$refs.simplert.openSimplert(modelCreatedModal)
        return false
      } else {
        this.validate['step3'] = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// Model-three.vue?68db6aca